import { network } from 'services/network';

export const logout = (params) => {
    return network.post('admin/bo/logout', params).then((response) => {
        return response.data;
    });
};
